import { avatarSrc } from "../lib/api";

// Equipped cosmetic frames (Phase C). Rendered as a premium ring/glow treatment
// around the avatar everywhere PlayerAvatar is used — one centralized place.
export const FRAME_STYLES = {
  "COSM-FRAME-GOLD": { ring: "ring-2 ring-[#E5B842]", glow: "0 0 0 3px rgba(229,184,66,0.18), 0 0 14px rgba(229,184,66,0.35)" },
  "COSM-FRAME-DARK": { ring: "ring-2 ring-[#6b7482]", glow: "0 0 0 3px rgba(107,116,130,0.22)" },
};

// Centralized player identity avatar. Real uploaded photo when avatar_url exists,
// otherwise the established neutral gold initials fallback (Phase 2 rule). The
// AI rank-position portraits remain decorative-only and are never routed here.
export function PlayerAvatar({ player, size = 56, shape = "rect", width, height, className = "", testid }) {
  const name = player?.display_name || "?";
  const initials = name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase() || "?";
  const src = avatarSrc(player?.avatar_url);
  const frame = FRAME_STYLES[player?.equipped_frame];
  const w = width || size;
  const h = height || size;
  const dim = { width: w, height: h };
  const ring = frame ? frame.ring : "ring-1 ring-[#E5B842]/40";
  const radius = shape === "rect" ? "rounded-lg" : "rounded-full";
  const base = `shrink-0 ${radius} overflow-hidden ${ring}`;
  const style = frame ? { ...dim, boxShadow: frame.glow } : dim;

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        data-testid={testid}
        data-frame={player?.equipped_frame || undefined}
        loading="lazy"
        style={style}
        className={`${base} object-cover bg-[#141414] ${className}`}
      />
    );
  }
  return (
    <div
      data-testid={testid}
      data-frame={player?.equipped_frame || undefined}
      style={style}
      className={`${base} grid place-items-center bg-[#141414] font-heading font-black text-[#E5B842] tracking-tight ${className}`}
    >
      <span style={{ fontSize: Math.round(Math.min(w, h) * 0.34) }}>{initials}</span>
    </div>
  );
}
